/* global Vue, Swiper */

import CldImg from './CldImg'

export default {
  name: 'PropertyCardGallery',
  components: { CldImg },
  template: `
    <div class="property-card__gallery">
      <div class="swiper" ref="slider">
        <div class="swiper-wrapper">
          <div v-for="(image, index) in property.propertyListingGallery" class="swiper-slide property-card__image">
            <CldImg :src="image" :alt="property.title" set-height preload />
          </div>
        </div>
      </div>
      <div class="card-slider__navigation">
        <div class="swiper-button-prev" ref="prev"></div>
        <div class="swiper-button-next" ref="next"></div>
      </div>
      <img
        v-if="property.groupLogoCircle"
        :src="property.groupLogoCircle"
        :alt="property.group"
        class="property-card__group-logo"
        loading="lazy"
        width="44"
        height="40">
    </div>
  `,
  props: {
    property: {
      type: Object,
      required: true,
    },
  },
  setup () {
    const slider = Vue.ref(null)
    const prev = Vue.ref(null)
    const next = Vue.ref(null)

    let swiper = null

    Vue.onMounted(() => {
      swiper = new Swiper(slider.value, {
        loop: true,
        navigation: {
          nextEl: next.value,
          prevEl: prev.value,
        },
      })
    })

    return {
      slider,
      swiper,
      prev,
      next,
    }
  },
}
